import React, { useState, useEffect } from "react";
import { Outlet, useParams } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";

const Event = () => {
  const { id } = useParams();

  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    JSON.parse(localStorage.getItem("sidebarCollapsed")) || false
  );

  useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(sidebarCollapsed));
  }, [sidebarCollapsed]);

  return (
    <div className="flex min-h-screen bg-white">
      <div className={`fixed h-screen transition-all duration-300 z-30 ${sidebarCollapsed ? "w-20" : "w-64"}`}>
        <Sidebar id={id} sidebarCollapsed={sidebarCollapsed} setSidebarCollapsed={setSidebarCollapsed} />
      </div>

      <div className={`flex-1 flex flex-col transition-all duration-300 ${sidebarCollapsed ? "ml-20" : "ml-64"}`}>
        <header className="sticky top-0 z-20 h-16 bg-white border-b border-slate-100 flex items-center justify-end px-8" style={{ boxShadow: "0 1px 8px 0 rgba(0,0,0,0.06)" }}>
          <Navbar />
        </header>
        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Event;